import { isNumber } from './is-number.es.js';
var isCubicBezier = function isCubicBezier(easing) {
  return Array.isArray(easing) && isNumber(easing[0]);
};
export { isCubicBezier };